import React from 'react';
import PropTypes from 'prop-types';
import { Block } from './Blocks';
import { DefaultText, LargeText, SmallGrayText } from './Paragraph';
const Title = _ref => {
  let {
    title,
    description,
    variant = 'medium',
    hideIfEmpty,
    center,
    titleFontWeight = 500,
    ...rest
  } = _ref;
  if (hideIfEmpty && !(title !== null && title !== void 0 && title.trim())) {
    return null;
  }
  switch (variant) {
    case 'small':
      break;
    case 'large':
      return /*#__PURE__*/React.createElement(Block, rest, description && /*#__PURE__*/React.createElement(SmallGrayText, {
        textAlign: center && 'center',
        textOverflow: "ellipsis"
      }, description), title && /*#__PURE__*/React.createElement(LargeText, {
        textAlign: center && 'center',
        textOverflow: "ellipsis"
      }, title));
    default:
      return /*#__PURE__*/React.createElement(Block, rest, description && /*#__PURE__*/React.createElement(SmallGrayText, {
        textAlign: center && 'center',
        textOverflow: "ellipsis"
      }, description), title && /*#__PURE__*/React.createElement(DefaultText, {
        fontWeight: titleFontWeight,
        textAlign: center && 'center',
        textOverflow: "ellipsis"
      }, title));
  }
};
Title.propTypes = {
  title: PropTypes.any,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(['small', 'medium', 'large']),
  hideIfEmpty: PropTypes.bool
};
export { Title };